export default "__VITE_ASSET__DQ9Rjohy__"